import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { t } from "i18next";
import CheckModifier from "./checkModifier";
import CheckModifiers from "./checkModifiers";
import OrderButton from "../orderButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileTextColor,
} from "../../../utility";
import { useState } from "react";

const OrdersDetails = (props) => {
  const [params, setParams] = useSearchParams();
  const [checked, setChecked] = useState(false);
  const [qty, setQty] = useState(1);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const addItemFuction = async (values) => {
    const { data: response } = await axios.post(
      `${process.env.REACT_APP_API}/basket-items`,
      values,
      {
        headers: {
          localization: localStorage.getItem("lang"),
        },
      }
    );
    return response.data;
  };

  const handleQuantityChange = (qty) => {
    setQty(qty);
  };

  const { mutate, isLoading, isSuccess } = useMutation(addItemFuction, {
    onSuccess: () => {
      props?.handleOpenToast(t("Order has been added successfully"), true);
      if (!checked) {
        setTimeout(() => {
          props?.close();
          navigate(
            `/${props?.tableName}/${props?.tableQr}/sections?section=${params.get("section") ? params.get("section") : '0'}&t=${params.get(
              "t"
            )}&lang=${localStorage.getItem("lang")}`
          );
        }, 1000);
      } else {
        setQty(1);
      }
    },
    onError: (res) => {
      props?.handleOpenToast(t(res.response.data.message), false);
    },
    onSettled: () => {
      queryClient.invalidateQueries("addToBasket");
    },
  });

  const customRadioStyles = {
    "& .MuiRadio-root": {
      color:
        localStorage.getItem("theme") === "dark" ||
          localStorage.getItem("theme") === "white"
          ? "#6BA5F2"
          : setMobileButttonBackColor(), // Color when not selected
    },
  };

  const customCheckStyles = {
    color:
      localStorage.getItem("theme") === "dark" ||
        localStorage.getItem("theme") === "white"
        ? "#6BA5F2"
        : setMobileButttonBackColor(), // Color when not selected
  };

  const modifiers =
    props?.item?.modifiers?.filter((element) => {
      return element?.order_options.length > 0;
    }) || [];

  return (
    <>
      <p
        style={{ color: setMobileTextColor() }}
        className="font-size-22 head-font"
      ></p>
      <Formik
        initialValues={{
          table: params.get("t"),
          item_id: props?.item?.id,
          modifiers: modifiers.map((element) => {
            return {
              id: element.group.id,
              max: element.max,
              min: element.min,
              order_options: [],
            };
          }),
          price_option: props?.selected ? props?.selected.id : null,
          quantity: 1,
          notes: "",
          menu_code: props?.tableQr,
          price: props?.selected ? props?.selected.price : props?.item?.price,
          token: localStorage.getItem("gustToken"),
          prevOptionPrice: 0,
        }}
        enableReinitialize
        onSubmit={(values) => {
          mutate(values);
        }}
      >
        {({ errors, setFieldValue, values, resetForm }) => (
          <Form>
            {modifiers?.map((modifier) => (
              <div key={modifier.group.id} className="m-top-12 alignByLang">
                <div className="d-flex justify-content-between">
                  <p
                    className="head-font font-size-16"
                    style={{ color: setMobileTextColor() }}
                  >
                    {modifier.group.name}{" "}
                    <span
                      className="sub-font font-size-16"
                      style={{ color: setMobileTextColor() }}
                    >
                      {modifier.required === 1
                        ? `(${t("Choose 1")})`
                        : `(${t("Choose")} ${modifier.min} ${t("to")} ${modifier.max
                        })`}
                    </span>
                  </p>
                  {modifier.required === 1 && (
                    <div>
                      <Button
                        variant="outlined"
                        className="head-font font-size-12 new-badge-style"
                        sx={{
                          borderColor: setMobileButttonBackColor(),
                          color: setMobileTextColor(),
                        }}
                      >
                        {t("Require")}
                      </Button>
                    </div>
                  )}
                </div>
                {modifier.required === 1 ? (
                  <FormControl className="d-block">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      className="d-block"
                      onClick={(e) => {
                        if (e.target.value) {
                          const array = [...values.modifiers];
                          const index = array.findIndex(
                            (element) => element.id === modifier.group.id
                          );
                          if (index === -1) {
                            const newModifier = {
                              id: modifier.group.id,
                              min: modifier.min,
                              max: modifier.max,
                              order_options: [JSON.parse(e.target.value).id],
                            };
                            array.push(newModifier);
                            setFieldValue("modifiers", array);
                            setFieldValue(
                              "price",
                              values.price + JSON.parse(e.target.value).price
                            );
                            setFieldValue(
                              "prevOptionPrice",
                              JSON.parse(e.target.value).price
                            );
                          } else {
                            const newModifier = { ...array[index] };
                            newModifier.order_options = [
                              JSON.parse(e.target.value).id,
                            ];
                            array[index] = newModifier;
                            setFieldValue("modifiers", array);
                            setFieldValue(
                              "price",
                              values.price +
                              JSON.parse(e.target.value).price -
                              values.prevOptionPrice
                            );
                            setFieldValue(
                              "prevOptionPrice",
                              JSON.parse(e.target.value).price
                            );
                          }
                        }
                      }}
                      sx={customRadioStyles}
                    >
                      <div className="sub-font">
                        {modifier?.order_options.map((element) => (
                          <CheckModifier
                            key={element.id}
                            order={element}
                            currency={props?.currency}
                            setFieldValue={setFieldValue}
                            values={values}
                            modifier={modifier}
                            handleOpenToast={props?.handleOpenToast}
                          />
                        ))}
                      </div>
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <FormGroup>
                    <div className="sub-font">
                      {" "}
                      {modifier?.order_options.map((element) => (
                        <CheckModifiers
                          key={element.id}
                          order={element}
                          currency={props?.currency}
                          setFieldValue={setFieldValue}
                          values={values}
                          modifier={modifier}
                          handleOpenToast={props?.handleOpenToast}
                        />
                      ))}
                    </div>
                  </FormGroup>
                )}
              </div>
            ))}

            <div className="m-top-12 alignByLang">
              <label
                htmlFor="quantity"
                className="font-size-14 mb-1 sub-font"
                style={{ color: setMobileTextColor() }}
              >
                {t("Quantity")}
              </label>
              <TextField
                id="quantity"
                name="quantity"
                type="number"
                inputProps={{
                  min: 1,
                  style: {
                    color: setMobileTextColor(),
                    backgroundColor: setMobileBackColor(),
                    borderWidth: 1,
                    borderColor: setMobileTextColor(),
                    borderStyle: "solid",
                    borderRadius: 4,
                  },
                }}
                value={qty}
                onChange={(e) => {
                  handleQuantityChange(e.target.value);
                  setFieldValue("quantity", parseInt(e.target.value));
                }}
                className="form-control"
                style={{
                  backgroundColor: setMobileBackColor(),
                  color: setMobileTextColor(),
                }}
              />
            </div>

            <div
              className="m-top-12 alignByLang"
              style={{
                marginBottom: "75px",
              }}
            >
              <label
                htmlFor="notes"
                className="font-size-14 mb-1 sub-font"
                onClick={resetForm}
                style={{ color: setMobileTextColor() }}
              >
                {t("Note")}
              </label>
              <TextareaAutosize
                id="notes"
                name="notes"
                minRows={3}
                className="form-control rounded-2 sub-font"
                style={{
                  resize: "none",
                  backgroundColor: setMobileBackColor(),
                  color: setMobileTextColor(),
                }}
                value={values.notes}
                onChange={(e) => setFieldValue("notes", e.target.value)}
                placeholder={t("Enter a note...")}
                inputprops={{
                  style: {
                    color: setMobileTextColor(),
                    backgroundColor: setMobileBackColor(),
                  },
                }}
              />
              <FormControlLabel
                control={<Checkbox style={customCheckStyles} />}
                className="mx-0 mt-2"
                label={
                  <span
                    className="sub-font font-size-16"
                    style={{ color: setMobileTextColor() }}
                  >
                    {t("Add and continue")}
                  </span>
                }
                onChange={(e) => setChecked(e.target.checked)}
              />
            </div>

            <OrderButton
              {...props}
              values={values}
              setFieldValue={setFieldValue}
              resetForm={resetForm}
              checked={checked}
              isLoading={isLoading}
              isSuccess={isSuccess}
              formQty={qty}
              handleQuantityChange={(qty) => setQty(qty)}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default OrdersDetails;
